<template>
  <div>
    <v-row>
      <v-col v-if="showFields.includes('department')" cols="12" md="4">
        <v-text-field
          v-model="form.department"
          name="department"
          :readonly="readonly"
          :error-messages="errors.department"
          :rules="getRulesByName('department')"
          :label="$t('PROFILE.DEPARTMENT')"
        />
      </v-col>

      <v-col v-if="showFields.includes('position')" cols="12" md="4">
        <v-text-field
          v-model="form.position"
          name="position"
          :readonly="readonly"
          :error-messages="errors.position"
          :rules="getRulesByName('position')"
          :label="$t('PROFILE.POSITION')"
        />
      </v-col>

      <v-col v-if="showFields.includes('mobilePhone')" cols="12" md="4">
        <phone-input
          v-model="form.mobile_phone"
          name="mobile_phone"
          :label="$t('PROFILE.WORK_MOBILE_PHONE')"
          :rules="getRulesByName('mobile_phone')"
          :error-messages="errors.mobile_phone"
        ></phone-input>
      </v-col>

      <v-col v-if="showFields.includes('phone')" cols="12" md="4">
        <phone-input
          v-model="form.phone"
          name="phone"
          :label="$t('PROFILE.WORK_PHONE')"
          :rules="getRulesByName('phone')"
          :readonly="readonly"
          :error-messages="errors.phone"
        ></phone-input>
      </v-col>

      <v-col v-if="showFields.includes('street')" cols="12" md="4">
        <v-text-field
          v-model="form.street"
          name="street"
          :readonly="readonly"
          :error-messages="errors.street"
          :rules="getRulesByName('street')"
          :label="$t('PROFILE.STREET')"
        />
      </v-col>

      <v-col v-if="showFields.includes('email')" cols="12" md="4">
        <v-text-field
          v-model="form.email"
          name="email"
          :readonly="readonly"
          :error-messages="errors.email"
          :rules="getRulesByName('email')"
          :label="$t('PROFILE.WORK_EMAIL')"
        />
      </v-col>

      <v-col v-if="showFields.includes('zip')" cols="12" md="4">
        <zip-code-input
          v-model="form.zip"
          :readonly="readonly"
          :error-messages="errors.zip"
          :rules="getRulesByName('zip')"
          @input="updateValue('zip', $event)"
        />
      </v-col>

      <v-col v-if="showFields.includes('city')" cols="12" md="4">
        <v-text-field
          v-model="form.city"
          name="city"
          :readonly="readonly"
          :error-messages="errors.city"
          :rules="getRulesByName('city')"
          :label="$t('PROFILE.CITY')"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mask } from 'vue-the-mask';
import formEditable from '@/modules/_global/mixins/form-editable';
import { email, textLine } from '@/modules/_global/variables/rules.js';
import ZipCodeInput from "@/modules/_global/_components/zip/ZipCodeInput";

export default {
  name: 'WorkProfileFrom',

  directives: {
    mask
  },

  components: {
    ZipCodeInput,
    PhoneInput: () => import('@/modules/_global/_components/phone/PhoneInput')
  },

  mixins: [formEditable],

  props: {
    showFields: {
      type: Array,
      default() {
        return [
          'department',
          'position',
          'mobilePhone',
          'phone',
          'street',
          'email',
          'zip',
          'city'
        ];
      }
    }
  },

  data: () => ({
    form: {
      department: '',
      position: '',
      mobilePhone: '',
      phone: '',
      street: '',
      email: '',
      zip: '',
      city: ''
    },
    rules: {
      department: textLine,
      position: textLine,
      mobilePhone: textLine,
      phone: textLine,
      street: textLine,
      email: email,
      zip: textLine,
      city: textLine
    }
  })
};
</script>
